import React from "react";
import {
  styled,
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  List
} from "@mui/material";

const StyledCheckbox = styled(Checkbox)(() => ({
  "& .MuiSvgIcon-root": {
    backgroundColor: "rgba(231, 231, 231, 1)",
  },
}));

export interface CheckInputInterface {
  options?: { label: string; isChecked: boolean }[];
  onChange: () => void;
}

const CheckboxInput = ({ options, onChange }: CheckInputInterface) => {

  return (
    <List
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        height: "300px",
        width: "300px",
      }}
    >
      {options &&
        options.map((item: any) => {
          return (
            <ListItem disablePadding>
              <ListItemButton role={undefined} onClick={onChange}>
                <ListItemIcon>
                  <StyledCheckbox
                    edge="start"
                    checked={item.isChecked}
                    color={"primary"}
                  />
                </ListItemIcon>
                <ListItemText id={item.label} primary={item.label} />
              </ListItemButton>
            </ListItem>
          );
        })}
    </List>
  );
};

export default CheckboxInput;
